import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { getParameter, saveParameter} from '../amazon.services';
import { Grid } from '@mui/material';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import IForm from '../../../components/i-form/i-form.component';
import { useNavigate } from 'react-router-dom';

const AmazonParameter = (props: any) => {
  const appContext = useContext(AppContext);
  const [paramData, setParamData] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    appContext.setShowLoader(true);
    getParameter(appContext,
      (response: any) => {
        setParamData(response.data);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }, []);

  const onSubmit = (data: any) => {
    appContext.setShowLoader(true);
    saveParameter(data, appContext,
      (response: any) => {
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
        navigate('/amazon/perf/order');
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} alignItems={'center'}>
      <Grid xs={3}>
        <INumberField name='inlandTransport' label='Inland Transport (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='originPort' label='Origin Port (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='oceanFreight' label='Ocean Freight (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='destinationPort' label='Destination Port (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='customDuty' label='Custom Duty (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='destinationClearance' label='Destination Clearance (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='otherCost' label='Contingency (% of Price)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='xneetiRate' label='Xneeti Rate (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='referralRate' label='Referral Rate (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='otherGain' label='Other Gain (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='adMarkup' label='Advertisement Markup (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='defaultTacos' label='Default TACOS (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='xneetiBase' label='Xneeti Base ($)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='invReimCharge' label='Inv Reim Charge (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='usaInvPct' label='USA Invoice (%)' required={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='overhead' label='Overhead (%)' required={true} />
      </Grid>
    </Grid>
  }

  return appContext.showLoader ? <></> : <IForm formData={paramData} title={'Parameter'} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default AmazonParameter;